import store from '@/store';
import { ROLES } from '@/config/constants';
import { decode } from 'jsonwebtoken';

export interface Specialization {
  customer?: string;
  product?: string;
  country?: string;
}

type Scope = Specialization[];

enum ScopeHeaderName {
  Product = 'X-IISY-PRODUCT',
  Country = 'X-IISY-COUNTRY',
  Customer = 'X-IISY-CUSTOMER'
}

export default class AuthorizationService {
  private roles: string | string[];
  private token: any;
  private _token: string | { [key: string]: any } | null;

  constructor() {
    // @ts-ignore
    this.roles = store.state.user.me.roles;
    // @ts-ignore
    this.token = store.state.auth.token;
    this._token = decode(this.token);
  }

  public scopeMatches(scope: Scope, customerProductCountry: Specialization): boolean {
    function subObject(a: any, b: any): boolean {
      /**
       * Checks whether every value of scope is in request
       */
      return Object.keys(a).every((key: string) => a[key] === b[key]);
    }
    return scope.some((specialization: Specialization) => {
      return subObject(specialization, customerProductCountry);
    });
  }

  public isCreator() {
    // @ts-ignore
    const roles = store.state.user.me.roles;

    return roles && !!roles.includes(ROLES.CREATOR);
  }

  public isAdmin() {
    // @ts-ignore
    const roles = store.state.user.me.roles;
    return roles && !!roles.includes(ROLES.ADMIN);
  }

  public isManager() {
    // @ts-ignore
    const roles = store.state.user.me.roles;
    return roles && !!roles.includes(ROLES.MANAGER);
  }

  public getRoles() {
    return this.roles;
  }
}
